import { render, staticRenderFns } from "./ResetPasswordComplete.vue?vue&type=template&id=1d0a182e&scoped=true&"
import script from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordComplete.vue?vue&type=style&index=0&id=1d0a182e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a182e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
